import React from "react";
import Header from "../components/layouts/Header";
import Footer from "../components/layouts/Footer";
import MaterialCalculator from "../components/sections/Calculadora/MaterialCalculator";
import TituloCalculadora from '../components/sections/Calculadora/TituloCalculadora';

const CalculadoraMaterialesPage = () => {
  return (
    <div>
      <Header />
      <TituloCalculadora /> 
      <MaterialCalculator />
      <Footer />
    </div>
  );
};

export default CalculadoraMaterialesPage;